import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { PipesModule } from '../../../pipes';
import { ReactiveFormTextareaComponent } from './reactive-form-textarea.component';

@NgModule({
  imports: [CommonModule, NzIconModule, I18nModule, ReactiveFormsModule, PipesModule, NgbTooltipModule],
  declarations: [ReactiveFormTextareaComponent],
  exports: [ReactiveFormTextareaComponent],
})
export class ReactiveFormTextareaModule {}
